import { snakeCase } from 'lodash'
import EmitAction from '@/directives/emit-action.directive'

const CLICK_EVENT = 'click'
const DOUBLE_CLICK_EVENT = 'dblclick'

const SUPPORTED_EVENTS = [CLICK_EVENT, DOUBLE_CLICK_EVENT]

function _getContextData(attrs) {
  const ahaAttributes = {}

  for (let i = 0; i < attrs.length; i++) {
    const attr = attrs[i]

    // Check if the attribute starts with 'aha-'
    if (attr.name.startsWith('aha-')) {
      // Remove the 'aha-' prefix and add to the object
      const key = attr.name.slice(4) // Remove 'aha-' from the key
      ahaAttributes[snakeCase(key)] = attr.value // Assign the value to the object
    }
  }

  return ahaAttributes
}

function _getCallbackKey(event) {
  return `aha-click-callback-${event}`
}

export default {
  bind(el, binding, vnode) {
    const contextData = {
      value: _getContextData(el.attributes),
    }

    // AHA-45710: register the emit-action tracking listeners BEFORE the action
    // listeners. Both are capture-phase on the same element and fire in registration
    // order, so tracking now runs before the action handler can tear the element
    // down (e.g. the product tour dismiss/next/done buttons), which previously
    // dropped the click_* event. This is behavior-preserving for elements that
    // survive the click: `aha-*` attributes only change via Vue re-render (async,
    // after the click), so the context read here is identical to the post-action
    // read below — the order change cannot alter the tracked props.
    EmitAction.bind(el, contextData, vnode)

    SUPPORTED_EVENTS.forEach((eventName) => {
      const callback = (e) => {
        // check if binding value is a function
        if (typeof binding.value === 'function') {
          binding.value(e)
          // update the context data
          contextData.value = _getContextData(el.attributes)
        }
      }
      el.addEventListener(eventName, callback, true)
      el[_getCallbackKey(eventName)] = callback
    })
  },
  unbind(el, binding, vnode) {
    EmitAction.unbind(el, binding, vnode)
    SUPPORTED_EVENTS.forEach((event) => {
      el.removeEventListener(event, el[_getCallbackKey(event)], true)
    })
  },
}
